import { render, staticRenderFns } from "./BackView.vue?vue&type=template&id=396dbd45&scoped=true"
import script from "./BackView.vue?vue&type=script&lang=js"
export * from "./BackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396dbd45",
  null
  
)

export default component.exports